import React from "react"
import classNames from "classnames"

import { getRoguelikeItem } from "@/utils/assets"

import styles from "./index.module.less"

interface ItemProps {
    type: "tool" | "relic"
    index?: number
    id: string
    name?: string
    className?: string
    style?: React.CSSProperties
}

const Item: React.FC<ItemProps> = (props) => {
    const { index, id, name, className, style, type } = props

    return (
        <div
            className={classNames(styles.item, className)}
            style={style}
            data-key={index}
            data-type={type}
        >
            <img src={getRoguelikeItem(id)} loading="lazy" />
            <div className={styles.name}>{name}</div>
        </div>
    )
}

export default Item
